import type { ReactNode } from "react";

import { twMerge } from "tailwind-merge";

export function Card({
  children,
  className,
  title,
}: {
  children: ReactNode;
  className?: string;
  title: string;
}) {
  return (
    <section
      className={twMerge(
        "flex flex-col gap-lg rounded-2xl border border-border-secondary bg-bg-primary p-xl",
        className,
      )}
    >
      <h3 className="text-lg font-semibold text-text-primary">{title}</h3>
      {children}
    </section>
  );
}
